/* ═══════════════════════════════════════════════════════════════
   MMB Monthly Club — JavaScript
   File: assets/mmb-club.js
   Requires: jQuery 3.7+ and Isotope 3.0+ (loaded in template)
   ═══════════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // Wait for jQuery + Isotope to be ready
  function initWhenReady(tries) {
    if (typeof $ === 'undefined' || typeof $.fn.isotope === 'undefined') {
      if (tries > 20) return; // give up after ~2 seconds
      setTimeout(function () { initWhenReady(tries + 1); }, 100);
      return;
    }
    initMMBClub();
  }

  initWhenReady(0);

  function initMMBClub() {

    /* ── ISOTOPE: Filterable product grid ───────────────── */
    var $grid = $('#mmb-product-grid').isotope({
      itemSelector: '.mmb-product-item',
      layoutMode: 'masonry',
      masonry: {
        columnWidth: '.mmb-grid-sizer',
        gutter: '.mmb-gutter-sizer'
      }
    });

    /* ── FILTER BUTTONS ─────────────────────────────────── */
    $('#mmb-filter-bar').on('click', '.mmb-filter-btn', function () {
      var filterValue = $(this).attr('data-filter');

      // Deactivate siblings in same group, activate clicked
      $(this).closest('.mmb-filter-group').find('.mmb-filter-btn').removeClass('active');
      $(this).addClass('active');

      $grid.isotope({ filter: filterValue });

      // Show/hide "no results" message
      var visible = $grid.data('isotope').filteredItems.length;
      $('#mmb-no-results').toggle(visible === 0);
    });


    /* ── STICKY BAR: Show after scrolling past hero ─────── */
    var cartCount = 0;

    $(window).on('scroll', function () {
      $('#mmb-sticky-bar').toggleClass('visible', $(this).scrollTop() > 600);
    });


    /* ── ADD TO CART ─────────────────────────────────────── */
    // This uses Shopify AJAX Cart API to add items without page reload
    $(document).on('click', '.mmb-add-btn', function (e) {
      e.preventDefault();

      var $btn       = $(this);
      var variantId  = $btn.data('variant-id');

      if (!variantId) {
        // Fallback: just go to product page
        window.location.href = $btn.attr('href');
        return;
      }

      // Disable button during request
      $btn.text('Adding…').prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: variantId },
        dataType: 'json',
        success: function (data) {
          cartCount++;
          $('#mmb-cart-count').text(cartCount);
          $btn.text('Added ✓').css('background', '#4A5C3A');
          setTimeout(function () {
            $btn.text('Add to Cart').css('background', '').prop('disabled', false);
          }, 2000);

          // Trigger Shopify cart drawer if theme has one
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        },
        error: function () {
          $btn.text('Try again').css('background', '#8B3A3A').prop('disabled', false);
          setTimeout(function () {
            $btn.text('Add to Cart').css('background', '');
          }, 2500);
        }
      });
    });


    /* ── FAQ ACCORDION ───────────────────────────────────── */
    $(document).on('click', '.mmb-faq-q', function () {
      var $item = $(this).closest('.mmb-faq-item');
      $('.mmb-faq-item').not($item).removeClass('open');
      $item.toggleClass('open');
    });

  } // end initMMBClub

}); // end DOMContentLoaded
